import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LawyerCardInfosType } from '../lawyer.types';
import { LawyerCardProfile } from '../card/LawyerCardProfile';
import { UserContext } from '../../user/UserContext';
import { EntitiesCardFooter } from '../../components/entities-card/EntitiesCardFooter';
import { EntitiesCardBody } from '../../components/entities-card/EntitiesCardBody';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';

type Props = {
  lawyer: LawyerCardInfosType;
  source: string;
};

export const LawyerPopoverCard: FC<Props> = ({ lawyer, source }) => {
  const { accessPremium } = useContext(UserContext);
  const { openRestrictedModal } = useRestrictedModal();
  const handleClick = (sourceCard: string) => () => {
    if (!accessPremium) {
      openRestrictedModal({ source: sourceCard });
    }
  };

  return (
    <>
      <EntitiesCardBody>
        <LawyerCardProfile
          lawyer={lawyer}
          href={
            accessPremium ? `${lawyer.url}?source=${source}-header` : undefined
          }
          onClick={handleClick(`${source}-header`)}
        />
      </EntitiesCardBody>
      <EntitiesCardFooter
        href={
          accessPremium ? `${lawyer.url}?source=${source}-footer` : undefined
        }
        onClick={handleClick(`${source}-footer`)}
      >
        <FormattedMessage id="app.entities.popover.footer" />
      </EntitiesCardFooter>
    </>
  );
};
